export default __webpack_public_path__ + "static/media/footer-pointer.e857b0a5.svg";